import { render, staticRenderFns } from "./CompanySubscription.vue?vue&type=template&id=00636557&scoped=true"
import script from "./CompanySubscription.vue?vue&type=script&lang=ts"
export * from "./CompanySubscription.vue?vue&type=script&lang=ts"
import style0 from "./CompanySubscription.vue?vue&type=style&index=0&id=00636557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00636557",
  null
  
)

export default component.exports